import { GOOGLE_API_KEY } from '@/constants/constants';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import { cn } from '@/lib/utils';

export type Place = {
  formatted_address: string;

  address_components: [
    {
      types: string[];
      long_name: string;
      short_name: string;
    },
  ];
  geometry: {
    location: {
      lat: () => number;
      lng: () => number;
    };
  };
};
type Props = {
  onChange: (place: Place) => void;
  placeholder?: string;
  geoType?: string;
  value?: string;
  defaultValue?: string;
  country?: string;
  size?: 'small' | 'large';
};
function AutocompleteInput({
  onChange,
  placeholder = '',
  geoType = 'geocode',
  value = '',
  size = 'small',
  country = '',
  defaultValue,
}: Props) {
  const options: Record<string, unknown> = { types: [geoType] };

  if (country) {
    (options as { componentRestrictions: { country: string } }).componentRestrictions = {
      country,
    };
  }

  const containerStyles = cn(
    'flex w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-within:outline-none focus-within:ring-1 focus-within:ring-ring md:text-sm',
    size === 'small' && 'h-9',
    size === 'large' && 'h-11',
  );

  return (
    <ReactGoogleAutocomplete
      apiKey={GOOGLE_API_KEY}
      onPlaceSelected={onChange}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange({ formatted_address: e.target.value } as Place)
      }
      className={containerStyles}
      options={options}
      placeholder={placeholder}
      value={value}
      defaultValue={defaultValue}
    />
  );
}

export default AutocompleteInput;
